module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: ({
      width: "" + (_vm.imageWidth + 60) + "px",
      height: "" + _vm.imageHeight + "px",
      margin: "30px 50px"
    })
  }, [(_vm.imageData) ? _c('div', {
    style: ({
      position: "relative",
      backgroundImage: "url(" + _vm.imageData + ")",
      backgroundRepeat: "no-repeat",
      backgroundSize: "contain",
      backgroundPosition: "center",
      backgroundSize: "" + _vm.imageWidth + "px " + _vm.imageHeight + "px",
      width: "" + _vm.imageWidth + "px",
      height: "" + _vm.imageHeight + "px"
    })
  }, _vm._l((_vm.artboards), function(artboard, key, index) {
    return _c('div', {
      style: ({
        color: "white",
        position: "absolute",
        left: "" + (key * (_vm.PREVIEW_ARTBOARD_PADDING + _vm.artboardWidth)) + "px",
        top: "" + (artboard.frame.y * _vm.artboardFactor) + "px",
        width: "" + _vm.artboardWidth + "px",
        height: "" + (artboard.frame.height * _vm.artboardFactor) + "px",
        boxSizing: "border-box"
      })
    }, _vm._l((artboard.layers), function(child) {
      return _c('layer', {
        key: child.do_objectID,
        attrs: {
          "layer": child,
          "artboard-width": _vm.artboardWidth,
          "artboard-factor": (_vm.artboardWidth / artboard.frame.width)
        }
      })
    }))
  })) : _vm._e(), _vm._v(" "), (!_vm.imageData) ? _c('div', [_c('dropzone', {
    on: {
      "changed": _vm.onFileChange
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "color": "red"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.error) + "\n    "), (_vm.error) ? _c('div', [_vm._v("\n      You can download Sketch 43 Beta here: "), _c('a', {
    attrs: {
      "href": "https://rink.hockeyapp.net/api/2/apps/0172d48cceec171249a8d850fb16276b?format=zip"
    }
  }, [_vm._v("Download")])]) : _vm._e()]), _vm._v(" "), _vm._m(0)], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/AnimaApp/sketch-web-viewer/raw/master/Fitness%20App.sketch"
    }
  }, [_vm._v("\n      Demo file\n    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5542f6d6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 118
// module chunks = 1